import { render, staticRenderFns } from "./PayDialog.vue?vue&type=template&id=fcfd16f8&scoped=true&"
import script from "./PayDialog.vue?vue&type=script&lang=ts&"
export * from "./PayDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PayDialog.vue?vue&type=style&index=0&id=fcfd16f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfd16f8",
  null
  
)

export default component.exports